import unauthorized from "../assets/padlock.png";

const Unauthorized = (error) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <img src={unauthorized} alt="padlock" />
      <h1>You don't have access to this page</h1>
    </div>
  );
};

export default Unauthorized;
